import { useEffect, useRef } from 'react';
import { AppState, AppStateStatus } from 'react-native';
import { supabase } from '../config/supabase';

/**
 * Tracks user activity by updating last_active_at in profiles.
 * Updates on app foreground and every 5 minutes while active.
 */
export function useActivityTracking(userId: string | undefined) {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!userId) return;

    const updateActivity = async () => {
      try {
        await supabase
          .from('profiles')
          .update({ last_active_at: new Date().toISOString() })
          .eq('id', userId);
      } catch (error) {
        // Silent fail — activity tracking is best-effort
      }
    };

    // Update immediately on mount
    updateActivity();

    // Update every 5 minutes
    intervalRef.current = setInterval(updateActivity, 5 * 60 * 1000);

    // Update on app foreground
    const subscription = AppState.addEventListener('change', (state: AppStateStatus) => {
      if (state === 'active') {
        updateActivity();
      }
    });

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      subscription.remove();
    };
  }, [userId]);
}
